import { render, staticRenderFns } from "./HeaderSearch.vue?vue&type=template&id=b12ae8be&scoped=true"
import script from "./HeaderSearch.vue?vue&type=script&lang=ts"
export * from "./HeaderSearch.vue?vue&type=script&lang=ts"
import style0 from "./HeaderSearch.vue?vue&type=style&index=0&id=b12ae8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12ae8be",
  null
  
)

export default component.exports